import cls from '@utils/css-select';
import Section from 'components/section';
import { SEOCONTENT } from 'pages/offical/homepage/const';
import React, { useEffect } from 'react';
import AddressBox from './component/address-box';
import AppraisalBox from './component/appraisal-box';
import FromTable from './component/form-table';
import GradeBlock from './component/grade-block';
import StepBox from './component/step-box';
import TechBlock from './component/tech-block';
import TraitBox from './component/trait-box';
import styles from './styles.scss';

const cx = cls(styles);

/**
 * 6过落地页
 */
export default function LandingHome(props: { location: any }) {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	useEffect(() => {
		const countryCode: string = props.location.pathname.slice(1)
		const seoContent: { title: string; desc: string; keyword: string } = SEOCONTENT[countryCode] || SEOCONTENT['default']
		if (seoContent !== undefined) {
			const title: HTMLTitleElement | null = document.querySelector('title')
			const descMeta: HTMLMetaElement | null = document.querySelector('meta[name=description]')
			const keywordMeta: HTMLMetaElement | null = document.querySelector('meta[name=keywords]')
			title && (title.innerText = seoContent.title)
			descMeta && (descMeta.setAttribute('content', seoContent.desc))
			keywordMeta && (keywordMeta.setAttribute('content', seoContent.keyword))
		}
	}, [])
	return (
		<div className={cx('landing-container')}>
			<FromTable />
			<AppraisalBox />
			<div className={cx('tech-eg')}>
				<Section>
					<h3 className={cx('block-title')}>Online 1-on-1 class, anywhere and anytime!</h3>
					<div className={cx('eg-list', 'scroll-view')}>
						<div className={cx('eg-item')}>
							<img loading="lazy" src="https://web-data.zmlearn.com/image/eQ4UjP5RkcpZsJJgerBfxK/11%402x.png" alt="air-class" />
							<div className={cx('txt')}>
								<h4>More convenient</h4>
								<p>Only you need is your PC/iPad</p>
							</div>
						</div>
						<div className={cx('eg-item')}>
							<img loading="lazy" src="https://web-data.zmlearn.com/image/qsRKMCezeBZbD4JmNp8QxG/12%402x.png" alt="air-class" />
							<div className={cx('txt')}>
								<h4>More Efficient</h4>
								<p>Real-time class interaction and ready for Q&A during the class</p>
							</div>
						</div>
						<div className={cx('eg-item')}>
							<img loading="lazy" src="https://web-data.zmlearn.com/image/cqG7tzfUQZ4YqhoXCykxAB/13%402x.png" alt="air-class" />
							<div className={cx('txt')}>
								<h4>More intelligent</h4>
								<p>Automatic recording and always available for review</p>
							</div>
						</div>
					</div>
				</Section>
			</div>
			<TechBlock />
			<GradeBlock />
			<StepBox />
			<TraitBox />
			<AddressBox />
		</div>
	);
}
